export const SETMENULISTGCG = "SETMENULISTGCG";
export const RESETMENULISTGCG = "RESETMENULISTGCG";
export const SETDETAILSGCG = "SETDETAILSGCG";
export const RESETDETAILSGCG = "RESETDETAILSGCG";